import styled from 'styled-components'
import BaseAvatar from 'components/Avatar'
import BaseRemoveMemberButton from '../RemoveMemberButton'
import Pill, { PillProps } from 'components/Pill'
import Tooltip from 'components/Tooltip'
import { truncateStyles } from 'components/Truncate'
import { breakpoint } from 'utils'

const RemoveMemberButton = styled(BaseRemoveMemberButton)`
  ${breakpoint('md')`
    display: none;
  `}

  position: absolute;
  left: 0;

  padding: 8px;

  border: none;
  background: transparent;
  color: ${({ theme }) => theme.colors.text.dark.tertiary};

  &:hover {
    color: ${({ theme }) => theme.colors.text.dark.secondary};
  }

  cursor: pointer;
`

const Wrapper = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin-left: -32px;
  padding: 16px 0 16px 32px;

  &:hover ${RemoveMemberButton} {
    display: block;
  }

  &:last-of-type {
    border-bottom: none;
    padding-bottom: 0px;
  }

  &:after {
    content: '';
    position: absolute;
    height: 1px;
    background-color: ${({ theme }) => theme.colors.border.dark.base};
    top: 0;
    right: 0;
    left: 32px;
  }
`

const Avatar = styled(BaseAvatar)`
  margin-right: 8px;
`

const StyledPill = styled(Pill)`
  margin-left: 8px;
`

const GuestBadge = styled(Pill).attrs<PillProps>({
  variant: { kind: 'secondary' },
  color: 'green',
})``

const TooltipWithTruncatedContent = styled(Tooltip)`
  overflow: hidden;
  display: flex;
`

const NoCommentIcon = styled.svg.attrs({
  role: 'img',
})`
  width: 12px;
  height: 12px;
  margin-left: 4px;
  margin-top: 3px; /* stylelint-disable-line scales/space */
  flex: 0 0 12px;
  opacity: 0.25;
`

const UserEmail = styled.div`
  ${truncateStyles}
  width: 100%;
  color: ${({ theme }) => theme.colors.text.dark.tertiary};
  font-size: ${({ theme }) => theme.fontSizes.tiny};
`

export {
  Wrapper,
  Avatar,
  RemoveMemberButton,
  StyledPill as Pill,
  TooltipWithTruncatedContent,
  GuestBadge,
  NoCommentIcon,
  UserEmail,
}
